<template>
    <div id="xl-nav">
  	 	<div class="logo">
			<img src="../images/xl_banner_03.png" alt="logo">
  	 	</div>
  	 	<ul>
			<li><router-link to="/"><div class="homep"><img src="../images/xl_banner_05.png" alt="首页"></div><span>首页</span></router-link></li>
			<li><a href="http://www.xianlaigame.com/#/gamecenter"><div class="gamep"><img src="../images/xl_banner_07.png" alt="游戏中心"></div><span>游戏中心</span></a></li>
			<li><a href="http://www.xianlaigame.com/#/activecenter"><div class="activep"><img src="../images/xl_banner_09.png" alt="活动中心"></div><span>活动中心</span></a></li>

  	 	</ul>
    </div>
</template>

<script>
export default {
	data(){
		return{
				
		}
	},
	methods:{
		
	}
}
</script>


// WEBPACK FOOTER //
// Nav.vue?6338e8b3